function getNestedChildHref(node: HTMLElement, force_single_loop = false) {
	if (!node.hasChildNodes()) {
		return [];
	}

	const result: HTMLAnchorElement[] = [];

	for (let i = 0; i < node.children.length; i++) {
		const child = node.children[i];

		if (child.tagName === "A") {
			result.push(child as HTMLAnchorElement);

			continue;
		}

		result.push(...getNestedChildHref(child as HTMLElement));
	}

	return result;
}

const classes_to_add = ["!text-opacity-100", "!text-white"];

window.onload = async () => {
	const table_of_contents = document.getElementById("table-of-contents");
	const toc_elements = getNestedChildHref(table_of_contents);

	const root_elements = [
		...(document.querySelectorAll(".is-top")?.values() ?? []),
	] as HTMLAnchorElement[];

	const anchors = toc_elements.map(
		(val) =>
			document.getElementById(val.href.split("#")[1]) as HTMLAnchorElement
	);

	const root_anchors = root_elements.map(
		(val) =>
			document.getElementById(val.href.split("#")[1]) as HTMLAnchorElement
	);

	window.addEventListener(
		"click",
		function (e) {
			var target = e.target;

			if (target instanceof Element) {
				if (!target.id.endsWith("-collapser")) {
					return;
				}

				target.children[0].classList.toggle("-rotate-90");

				const all = document.querySelectorAll(
					`[parent-id="${target.id}"]`
				);

				all.forEach((val) => val.classList.toggle("hidden"));
			}
		},
		false
	);

	window.addEventListener("scroll", (event) => {
		highlightTOCElements(toc_elements, anchors);
		highlightTOCElements(root_elements, root_anchors);
	});
};

function highlightTOCElements(
	elements: HTMLAnchorElement[],
	anchors: HTMLAnchorElement[]
) {
	let scrollTop = window.scrollY;

	// highlight the last scrolled-to: set everything inactive first
	elements.forEach((link, index) => {
		for (const class_name of classes_to_add) {
			link.classList.remove(class_name);
		}
	});

	// then iterate backwards, on the first match highlight it and break

	let found_element: HTMLAnchorElement = null;
	for (var i = anchors.length - 1; i >= 0; i--) {
		if (scrollTop > anchors[i].offsetTop - 10) {
			found_element = elements[i];
			break;
		}
	}

	const highlighted_element = found_element ?? elements[0];

	const elements_to_highlight = [
		highlighted_element,
		...elements.filter((val) => val.href === highlighted_element.href),
	];

	// Because there is a hidden TOC, we need to highlight all elements that match
	for (const element of elements_to_highlight) {
		for (const class_name of classes_to_add) {
			element.classList.add(class_name);
		}
	}
}
